module.exports = __webpack_public_path__ + "2c42cbdf7d0ce495ecdf98dd1671e9ff.jpg";